<template>
    <i v-bind:class="'fa fa-' + faIcon"></i>
</template>

<script>
    /**
     * @param {String} type
     */
    export default {
        name: "FileIconItem",
        props: {
            type: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                faIcon: 'file-o text-dark'
            };
        },
        created() {
            switch (this.type) {
                case 'pdf':
                    this.faIcon = 'file-pdf-o text-danger';
                    break;

                case 'xls':
                case 'xlsx':
                case 'csv':
                    this.faIcon = 'file-excel-o text-success';
                    break;

                case 'doc':
                case 'docx':
                    this.faIcon = 'file-word-o text-info';
                    break;

                case 'ppt':
                case 'pptx':
                    this.faIcon = 'file-powerpoint-o text-danger';
                    break;

                case 'zip':
                case 'rar':
                    this.faIcon = 'file-archive-o text-muted';
                    break;

                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'gif':
                    this.faIcon = 'file-image-o text-info';
                    break;

                case 'txt':
                    this.faIcon = 'file-text-o text-dark';
                    break;

                case 'htm':
                case 'html':
                case 'php':
                case 'js':
                case 'css':
                case 'vue':
                case 'scss':
                case 'sass':
                    this.faIcon = 'file-code-o text-dark';
                    break;

                default:
                    break;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/item/FileIcon.vue